<template>
  <b-modal
      v-model="visible"
      title="ویرایش سگمنت پایه"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      :no-close-on-backdrop="true"
      size="sm"
      @ok="save"
  >
    <b-form @submit.prevent>
      <b-row>
        <b-col md="12">
          <b-form-group
              label="عنوان"
              label-for="Family"
          >
            <b-form-input
                v-model="title"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group class="mt-1 mb-2">
            <b-form-checkbox v-model="autoInsertNewUser" class="custom-control-info">
              کاربران جدید به این سگمنت اضافه شوند
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: "editSegmentBase",
  props: {
    show: { type: Boolean, default: false },
    item: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      title: '',
      autoInsertNewUser: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(val) {
        return this.$emit('update:show', !!val)
      }
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.title = val.Title
        this.autoInsertNewUser = val.AutoInsertNewUser
      }
    },
    visible(val) {
      if (!val) {
        this.title = ''
        this.autoInsertNewUser = false
      }
    }
  },
  methods: {
    save(modalEvt) {
      modalEvt.preventDefault()
      this.loading = true
      this.$http.post(this.$api.segmentBasic.changeTitle,
          {
            Id: this.item.Id,
            Title: this.title,
            AutoInsertNewUser: this.autoInsertNewUser
          }
      )
          .then(response => {
            this.$emit('update', response.data)
            this.loading = false
            this.visible = false
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>